import { Box, Skeleton, Stack } from '@mui/material'

import { Text } from '@/local/components'

import { type GpsInfoWithColor } from '../../../../../types'
import { useTexts } from '../useTexts'
import { VehicleTag } from './VehicleTag'

interface Props {
  vehicle: uui.domain.client.UnifiedVehicle
  point: GpsInfoWithColor
}

export function VehicleInfo(props: Props) {
  const { vehicle, point } = props

  const texts = useTexts()

  if (!vehicle.hasRoutingLicense) return null

  return (
    <Box minWidth={260} height={46}>
      <Stack direction="column" height="100%" justifyContent="space-between">
        <Text weight="$semiBold">{`${vehicle.vehicle.externalId} - ${texts.breadcrumbPoint}`}</Text>

        <Stack direction="row" height="100%" alignItems="center">
          <VehicleTag vehicle={vehicle} />
          <Box marginLeft={1}>
            {point.address ? (
              <Text size="$s" italic>
                {point.address}
              </Text>
            ) : (
              <Skeleton width={200} height={29} animation="wave" />
            )}
          </Box>
        </Stack>
      </Stack>
    </Box>
  )
}
